export default "__VITE_ASSET__0xN3J$8d__"